<app-maintenace-order-detail
  [registerMaintenance]="true" (registerMaintenanceEvent)="registerMaintenance($event)">
</app-maintenace-order-detail>
